import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './services/redux-store';
import { ClientContextProvider } from 'react-fetching-library';
import { HelmetProvider } from 'react-helmet-async';
import { LicenseInfo } from '@mui/x-license-pro';
import { I18nextProvider } from 'react-i18next';
import { Toaster } from 'react-hot-toast';

import i18n from './i18n';
// scroll bar
import 'simplebar/src/simplebar.css';

import './index.css';
import { client } from './services/request';
import { SettingsProvider } from './services/contexts/SettingsContext';
import { CollapseDrawerProvider } from './services/contexts/CollapseDrawerContext';
import { App } from './App';

LicenseInfo.setLicenseKey(
  'dec528303a4ee3fc0dd5f77e4bfda901T1JERVI6NDI2MjIsRVhQSVJZPTE2ODI2Nzk2MTIwMDAsS0VZVkVSU0lPTj0x'
);

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <ClientContextProvider client={client}>
          <SettingsProvider>
            <CollapseDrawerProvider>
              <BrowserRouter>
                <I18nextProvider i18n={i18n}>
                  <App />
                  <Toaster
                    position="bottom-right"
                    reverseOrder={false}
                    toastOptions={{ duration: 4000 }}
                  />
                </I18nextProvider>
              </BrowserRouter>
            </CollapseDrawerProvider>
          </SettingsProvider>
        </ClientContextProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
